/**
 * Phone number used for app login SMS 2FA.
 * Excludes businessPhone — that is the company line, not the owner's mobile.
 */
export function resolveTwoFactorPhone(user) {
  return String(user?.phone || user?.personalPhone || '').trim();
}

export function maskTwoFactorPhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.length < 4) return '';
  return `***-***-${digits.slice(-4)}`;
}
